import { useState } from 'react';

// import { routeTypes } from '../../../useSystemRoutes'
// import { useSystemPrompt } from '../../../useSystemPrompt';

import { documentTypes } from "../../../api/useDocuments"
import { validateRouteType } from './default';

import {
    useDependencies,
    targetTypes as dependencyTargetTypes,
    dependencyModules,
    dependencyRelations,
    dependencyRefs,
    formikDependencyStateField,
} from "../../../api/useDependencies"

export function useStateItemTransform() {

    const { getDependencyItem } = useDependencies()

    // const { promptMessage } = useSystemPrompt()

    // const validateRouteType = (val) => {
    //     if(val !== routeTypes.admin) throw new Error(`Unsupported route : ${val}`)
    // }

    const updateFormikState = async ({
        data,
        routeType,
        setFieldValue,
    }) => {

        // validateRouteType(routeType);
        validateRouteType(routeType, documentTypes.itemTransform)

        const {
            document,
            items
        } = data

        const itemValues = items.select_items
        const transfromItemValues = items.transform_items

        // only load these fields
        setFieldValue(`remark`, document?.doc_remark ? document.doc_remark : "")

        items.forEach((e, index) => {
            setFieldValue(`rows.${index}.itemId`, e?.item_id)
            setFieldValue(`rows.${index}.name`, e?.item_name)
            setFieldValue(`rows.${index}.code`, e?.code)
            setFieldValue(`rows.${index}.description`, e?.description)
            setFieldValue(`rows.${index}.qty`, e?.qty)
            setFieldValue(`rows.${index}.uomId`, e?.uom_id)
            setFieldValue(`rows.${index}.uomName`, e?.uom_name)

            // const selectedItem = e.select_item_uid
            // selectedItem.forEach((item, index) => {
            //     setFieldValue(`rows.${index}.transformToRackId`, item?.rack_id)
            //     setFieldValue(`rows.${index}.transformToSlotId`, item?.slot_id)
            //     setFieldValue(`rows.${index}.transformToBatchNo`, item?.custom_batch_no)
            //     setFieldValue(`rows.${index}.transformToExpiryData`, item?.expiry_date)
            // })
        })

        // transfromItemValues.forEach((e, index) => {
        //     setFieldValue(`rows.${index}.itemId`, e?.item_id)
        //     setFieldValue(`rows.${index}.name`, e?.item_name)
        //     setFieldValue(`rows.${index}.code`, e?.code)
        //     setFieldValue(`rows.${index}.description`, e?.description)
        //     setFieldValue(`rows.${index}.qty`, e?.qty)
        //     setFieldValue(`rows.${index}.uomId`, e?.uom_id)
        //     setFieldValue(`rows.${index}.uomName`, e?.uom_name)
        // })

        setFieldValue(`userId`, document?.user_id)
        setFieldValue(`username`, document?.profile_name)

        let depStates = getDependencyItem({
            targetType: dependencyTargetTypes.document,
            dependencyModule: document?.type.toLowerCase(),
            dependencyRef: dependencyRefs.document,
            targetId: document?.id,
            relation: dependencyRelations.reference,
        })

        setFieldValue(formikDependencyStateField, [depStates])

    }

    const getFormikDependencyStates = ({ values }) => {
        return {
            [`${formikDependencyStateField}`]: values[`${formikDependencyStateField}`]
        }
    }

    return {
        updateFormikState,
        getFormikDependencyStates

    }

}